import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73ce89de&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HorizontalEntityCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HorizontalEntityCard/index.vue').default,ExcursionCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ExcursionCard/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default})
